import { render, staticRenderFns } from "./WebsitePromos.vue?vue&type=template&id=700d0ec8&scoped=true&"
import script from "./WebsitePromos.vue?vue&type=script&lang=js&"
export * from "./WebsitePromos.vue?vue&type=script&lang=js&"
import style0 from "./WebsitePromos.vue?vue&type=style&index=0&id=700d0ec8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700d0ec8",
  null
  
)

export default component.exports